export type GameCategoryFormKey = 'game_name';

const gameCategoriesListMap = [
	{
		label: 'Game Category ID',
		value: 'game_category_id',
	},
	// {
	// 	label: 'Game Category Master',
	// 	value: 'game_category_master',
	// },
	{
		label: 'Game Category Name',
		value: 'game_category_name',
	},
];

const columnFormatter = {
	game_category_id: 'value',
	game_category_name: 'value',
	// game_category_master: 'master',
};

const formNameMap = {
	name: 'Game name',
};

export { gameCategoriesListMap, columnFormatter, formNameMap };
